const getters = {
  welfareCard: state => state.welfareCard,
  getAdddreId: state => state.addressId,
  getPayInfo: state => ({
    payInfo: state.payInfo || [],
    payType: state.payType || ''
  }),
  orderId: state => state.orderId,
  addressInfo: state => state.addressInfo,
  cakeShop: state => state.cakeShop,
  cakeDelivery: state => state.cakeDelivery
}

export default getters
